const dayOfMonthNormalize = (value, prevValue) => {
    if (!value || value >= 1 && value <= 31) return value;

    return prevValue;
};

export default dayOfMonthNormalize;
